import { useCallback, useEffect, useState } from "react";
import { Box, Button, Drawer, IconButton, Typography, } from "@mui/material";
import EastIcon from '@mui/icons-material/East';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { useDispatch } from "react-redux";
import { getUsersAllData } from "../../../../actions/usersAllData";
import { useNavigate } from "react-router";



const TicketsDrawer = ({ open, onClose, item }) => {
    // hooks
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Local State
    const [isMount, setisMount] = useState(false);
    const [loading, setloading] = useState(true);
    const [Data, setData] = useState([]);

    // Api calls for get Order
    const getData = useCallback(
        async (id, orders) => {
            const res = await dispatch(getUsersAllData(item?._id, "tickets"));
            setData(res?.data?.data);
            setloading(false);
        },
        [dispatch]
    );

    useEffect(() => {
        getData()
    }, [open]);


    return (
        <>
            <Drawer anchor="right"
                open={open}
                onClose={onClose}
                sx={{
                    "& .MuiDrawer-paper": {
                        top: "0px  !important",
                        backgroundColor: "#fafafa",
                        padding: "10px",
                    },
                    "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                        top: "0px !important"
                    }
                }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", marginTop: 2, p: 1 }}>
                        <Typography
                            className="sofiaRegular"
                            color="#222020"
                            variant="body1"
                            fontWeight="bold"
                            sx={{ fontSize: "16px" }}
                        >
                            Tickets
                        </Typography>
                        <Typography
                            className="sofiaRegular"
                            variant="body2"
                            sx={{ fontSize: "14px", color: "#1b1919" }}
                        >
                            {Data?.length} ticket
                        </Typography>
                    </Box>
                    <IconButton sx={{ color: 'red', cursor: "pointer", backgroundColor: "transparent", "&:hover": { backgroundColor: "transparent" } }} onClick={onClose}>
                        <CancelRoundedIcon />
                    </IconButton>
                </Box>
                <Box sx={{ mt: 5 }}>
                    {Data?.length > 0 ? (Data?.map((order, index) => (
                        <Box
                            key={order._id}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "2px 10px",
                                mb: 1,
                                height: "70px",
                                backgroundColor: "#ffffff",
                                border: "1px solid #ececec",
                                borderRadius: "6px"
                                // boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
                            }}
                        >
                            {/* Image */}
                            <Box
                                component="img"
                                src={order?.orderItemId?.mainImage}
                                alt={order.id}
                                sx={{
                                    width: 50,
                                    height: 50,
                                    borderRadius: 1,
                                    objectFit: "contain",
                                    border: "1px solid #E0E0E0",
                                }}
                            />

                            {/* Order Details */}
                            <Box sx={{ flex: 1, ml: 2 }}>
                                <Typography
                                    className="sofiaRegular"
                                    sx={{ fontWeight: "bold", fontSize: 16, color: "#000", lineHeight: 0.9 }}>
                                    {`${order?.ticketId} | ${order?.status}`}
                                </Typography>
                                <Typography
                                    className="sofiaRegular"
                                    sx={{ fontSize: 14, color: "#000", lineHeight: 0.9, mt: 0.5 }}>
                                    {[order.reason]}
                                </Typography>
                            </Box>

                            {/* View Order Button */}
                            <Button
                                onClick={() => navigate(`/admin/all-tickets?ticketId=${order?.ticketId}`)}
                                className="sofiaRegular"
                                sx={{
                                    fontWeight: "bold",
                                    fontSize: 14,
                                    color: "black",
                                    textTransform: "none",
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "0px !important",
                                    lineHeight: 0.9,
                                    bgcolor: "transparent", // Ensures initial background is transparent
                                    "&:hover": {
                                        bgcolor: "transparent", // Keeps background transparent on hover
                                    },
                                }}
                                endIcon={<EastIcon sx={{ fontSize: 16 }} />}
                            >
                                View Ticket
                            </Button>
                        </Box>
                    ))
                    ) : (
                        <Typography className="sofiaRegular" sx={{ color: "#000", textAlign: "center", mt: 2 }}>
                            No tickets found.
                        </Typography>
                    )}
                </Box>

            </Drawer>
        </>
    )
}


export default TicketsDrawer